import { getIsApiPending, getQuote, getQuoteForm, getSelectedCoverOption } from '../../../selectors/afyaImara/quote';
import { apiTransitionShareQuoteForm, shareQuoteSuccess, shareQuoteFailure } from '../../../actions/afyaImara/quote';
import { getAccessToken } from '../../../selectors/afyaImara/payments';
import axios from 'axios';
import { getAgeFromDateString } from './payloadCollection';

export const shareQuoteService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionShareQuoteForm.pending());
            try {
                const resp = await share(store.getState());
                store.dispatch(shareQuoteSuccess(resp.data));
                store.dispatch(apiTransitionShareQuoteForm.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionShareQuoteForm.failure());
                store.dispatch(shareQuoteFailure(e));
            }
        }
    })();
    return next(action);
};

const shareQuotePayload = (state) => {
    const quotation = getQuoteForm(state);
    const quote = getQuote(state);
    const premiumCalculationPayload = {
        email: quotation.shareEmail.value || "N/A",
        phoneNumber: 'N/A',
        countryCode: 'KE',
        productId: quote?.productId || 0,
        age: getAgeFromDateString(quotation?.dob?.value) || 0,
        inPatient: {
            inpatientLimitId: quotation?.inpatientCover?.value || 0,
        },
        outPatient: {
            present: quotation?.outpatientCover?.value ? true : false,
            outpatientLimitId: quotation?.outpatientCover?.value || 0,
            option: quotation?.outpatientCover?.value || 0,
        },
        familyMembers: {
            children: {
                count: quotation?.childrenDobs?.value?.length || 0,
            },
            spouse: {
                age: parseInt(quotation?.spouseDob?.value) || 0,
            },
        },
    };
    return {
        ...premiumCalculationPayload,
    };
};

const share = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-afya-imara/share-quote';
        return await axios.post(url, shareQuotePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
